module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "updateRemark"
  }, [_c('mt-popup', {
    staticClass: "guestInfo",
    attrs: {
      "popup-transition": "popup-fade"
    },
    model: {
      value: (_vm.bupdateRemark),
      callback: function($$v) {
        _vm.bupdateRemark = $$v
      },
      expression: "bupdateRemark"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('updateRemark_title')))]), _vm._v(" "), _c('div', {
    staticClass: "guestSwiper"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.req.remark),
      expression: "req.remark"
    }],
    staticClass: "remark",
    attrs: {
      "placeholder": _vm.$t('placeHolder_Empty')
    },
    domProps: {
      "value": (_vm.req.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.req, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "unSure",
    on: {
      "click": function($event) {
        _vm.bupdateRemark = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _vm._v(" "), _c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0638ea74","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/fangTXQ/fangTXQ-comp/updateRemark.vue
// module id = 1725
// module chunks = 107